import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { filter, map }         from 'rxjs/operators';

interface EventBusMessage {
  name: string;
  payload?: any;
}

@Injectable({ providedIn: 'root' })
export class EventBusService {
  private eventSubject = new Subject<EventBusMessage>();

  broadcast(name: string, payload?: any): void {
    this.eventSubject.next({ name, payload });
  }

  on<T = any>(name: string): Observable<T> {
    return this.eventSubject.asObservable().pipe(
      filter(event => event.name === name),
      map(event => event.payload as T)
    );
  }
}
